/* unplugin-vue-components disabled */import script from "./MenuPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuPanel.vue?vue&type=script&setup=true&lang=js"

import "./MenuPanel.vue?vue&type=style&index=0&id=425fb23e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-425fb23e"]])

export default __exports__